import { acceptHMRUpdate, defineStore } from 'pinia'

export const useLeagueStore = defineStore('league', {
  state: () => ({
    id: null,
    slug: null,
    name: null,
    season: null,
    teams: [],

    // // Debugging
    // _raw: null,
  }),

  actions: {
    async addLeague(data) {
      this.id = data?.id
      this.slug = data?.slug
      this.name = data?.name
      this.season = data?.season
      this.teams = data?.teams

      // // RAW data for debugging
      // this._raw = data
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLeagueStore, import.meta.hot))
}
